import { getPrivateApi } from "../lib/axiosConfig";

const api = getPrivateApi();

export const postNotification = async (title: string, message: string) => {
  try {
    const response = await api.post("/notification/send", {
      title,
      message,
    });

    return response;
  } catch (error) {
    throw new Error("Falha ao enviar notificação", error as any);
  }
};
